import Alpine, { AlpineComponent } from "alpinejs";

// export function imgDataContext() {
//   return {
//     init() {
//       if ((this.$el as HTMLImageElement).loading === "lazy") {
//         this.$el.classList.add("lazy");
//       }
//     },

//     loaded(e: Event) {
//       (e.target as HTMLElement)?.classList.remove("lazy");
//     },

//     error(e: Event) {
//       (e.target as HTMLElement)?.classList.add("error");
//     },
//   } /* as AlpineComponent */;
// }

// export function registerImgDataContext() {
//   Alpine.data("vrsImg", imgDataContext);
// }

export function defineXComponent<T>(name: string, component: new () => any) {
  Alpine.data(name, (...initialStateArgs: unknown[]) => {
    const $data = (initialStateArgs?.[0] as Partial<T>) ?? null;
    return Object.assign({}, (component as any).$defaultData ?? {}, $data ?? {}, {
      $component: new component(),
      init() {
        const scope = this as any;

        const { $el, $component } = scope as {
          $el: HTMLElement;
          $component: any;
        };

        const initExpression = $el.getAttribute("x-init");

        if (initExpression == null && $component && $component.$data == null) {
          if ($component.init instanceof Function) {
            $component.init(scope);
          } else {
            $component.$data = scope;
          }
        }
      },
    });
  });
}
